module.exports = __webpack_public_path__ + "fonts/icomoon.eot";


//////////////////
// WEBPACK FOOTER
// ./src/assets/css/fonts/icomoon/icomoon.eot?1ki0q8
// module id = 116
// module chunks = 0